import PropTypes from 'prop-types';

import layoutConfig from 'common/searchLayoutConfig';
import styles from 'styles/components/search/layout.scss';

const optionKeys = Object.keys(layoutConfig);

/**
 * Returns true if the layout is valid
 * @param  {string}  layout layout to check if valid
 * @return {Boolean}
 */
export const isValidLayout = layout => layout in layoutConfig;

/**
 * Make options for each layout
 * @return {object[]} layout options
 */
const makeOptions = () => optionKeys.map(key => <option key={key} value={key}>{layoutConfig[key].label}</option>);

/**
 * Layout component for selecting search layouts
 * @param {function}  onLayoutSelected callback when a new layout is selected
 * @param {string}    selectedLayout   currently selected layout
 */
const Layout = ({ onLayoutSelected, selectedLayout }, { testId }) => (
  <div className={styles.searchLayout}>
    <label htmlFor="searchViewLayout">View</label>
    <select
      id="searchViewLayout"
      value={selectedLayout || ''}
      onChange={onLayoutSelected}
      data-test-id={testId('selectLayoutValue')}>
      {makeOptions()}
    </select>
  </div>
);

Layout.propTypes = {
  onLayoutSelected: PropTypes.func.isRequired,
  selectedLayout: PropTypes.string
};

Layout.contextTypes = {
  testId: PropTypes.func
};

export default Layout;
